const l = `<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path
            d="M27.88 40.753a2.3 2.3 0 001.686-.734l19.487-20.07a2.22 2.22 0 00.68-1.62c0-.44-.1-.836-.302-1.19a2.228 2.228 0 00-.818-.835A2.265 2.265 0 0047.442 16c-.621 0-1.167.22-1.637.658L26.52 36.475h2.694L9.928 16.658A2.268 2.268 0 008.29 16c-.436 0-.827.101-1.17.304-.345.202-.617.48-.819.835-.201.354-.302.75-.302 1.19a2.287 2.287 0 00.68 1.645l19.487 20.045c.504.489 1.074.734 1.712.734z"
            fill="currentColor" fill-rule="nonzero" />
        <path d="M0 0h56v56H0z" />
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=arrow-down.es.BAIHdBJX.js.map
